import RecommendationService from '@/services/recommendation.service';
import { Notification } from 'element-ui';
import { maxQueueLength } from '@/services/recommendation.service';
import EnquiryService from "@/services/enquiry.service";

export default {
	emits: ['venues-list-updated'],
    computed: {
        roomScoreClasses() {
            return function (score) {
                let classes = 'venue-rating';

                if (score >= 0 && score <= 33.3) {
                    classes += ' low';
                } else if(score > 33.3 && score <= 66.66) {
                    classes += ' med';
                } else {
                    classes += ' high';
                }

                return classes;
            }
        },
        roomsSelectedForRecommendation() {
            return this.$store.getters['recommendations/getSelectedVenueRoomsForRecommendation'](this.leadEventId);
        },
		isCountryAU() {
			return this.leadInfo.country?.toUpperCase() === 'AU';
		},

		isCountryUK() {
			return this.leadInfo.country?.toUpperCase() === 'UK';
		},
        auWeddingTemplateMessages() {
			return this.line(`Congratulations on your engagement, I just tried to give you a quick call!`, true) +
				this.line(`Have you had a chance to look over the brochure you downloaded for ${this.leadInfo.last_enquired_venue.name}? I would love to organise a venue tour for you!`, true) +
				this.portalLinkMessage(EnquiryService.EVENT_TYPE_WEDDING) +
				this.line(`I work with a range of gorgeous venues and I'm always happy to chat through the many options that'll work within the scope of your wedding vision and budget.`);
		},

		auCorporateTemplateMessages() {
			return this.line(`Thank you for your event enquiry.`, true) +
				this.line(`I have added an initial list of some of my top recommended venues for you below, and into your personal Venue Crew dashboard! You can login <a href="${this.portalLoginLink}">here</a> and let me know which ones you like the best, request for quotes and date availabilities as well as hide any that you are not interested in at this stage or get some more recommendations.`, true) +
				this.line(`I work with a range of amazing venues and I’m always happy to chat through the many options that’ll work within the scope of your event vision and budget.`);
		},

		ukCorporateTemplateMessages() {
			return this.line(`Hope you’re well?`, true) +
				this.line(`Have you had a chance to look over the brochure you downloaded for ${this.leadInfo.last_enquired_venue.name}?`, true) +
				this.line(`Based on the style of the venues you have selected, I've identified some additional spaces below that I think you might/would also like. Let me know your thoughts and/or if you’d like to view any venues so I can arrange viewings for you :)`, true) +
				this.line('These are all collated onto your personal Venue Crew dashboard. You can login <a href="' + this.portalLoginLink + '">here</a> where you can let me know which ones you like/want to view or get more recommendations.');
		},

		ukWeddingTemplateMessages() {
			return this.line(`Hope you’re well?`, true) +
				this.line(`Have you had a chance to look over the brochure you downloaded for ${this.leadInfo.last_enquired_venue.name}?`, true) +
				this.line(`Based on the style of the venues you have selected, I've identified some additional spaces below that I think you might/would also like. Let me know your thoughts and/or if you’d like to view any venues so I can arrange viewings for you :)`, true) +
				this.line('These are all collated onto your personal Venue Crew dashboard. You can login <a href="' + this.portalLoginLink + '">here</a> where you can let me know which ones you like/want to view or get more recommendations.');
		},

		auEmailTemplate() {
			return this.line(`Hey ${this.leadInfo.first_name},`, true) +
				(
				this.leadInfo.is_corporate_event ? this.auCorporateTemplateMessages : this.auWeddingTemplateMessages
				) +
				this.line(`If you have any questions ` + (this.leadInfo?.is_corporate_event ? 'about the venues I work with' : '') + `, please don't hesitate to reach out.`) +
				this.line(`I look forward to hearing from you soon!`);
		},

		ukEmailTemplate() {
			return this.line(`Hi ${this.leadInfo.first_name},`, true) +
				(
				this.leadInfo.is_corporate_event ? this.ukCorporateTemplateMessages : this.ukWeddingTemplateMessages
				) +
				this.line(`Our services are completely free so there are no costs involved. Take a look at some of our reviews from our past clients!`) +
				this.line(`I look forward to hearing from you soon!`);
		},

		ukQuickEmailTemplate() {
			return this.line(`Hi ${this.leadInfo.first_name},`, true) +
			this.line(`Congratulations on your engagement — such an exciting time for you both!`) +
			this.line(`I would love to help find the perfect venue for your big day! I’m a Wedding Venue Specialist here at Easy Weddings & Venue Crew.`) +
			this.line(`Based on the details you’ve shared about your guest numbers and desired budget, these are a few venues that I believe would be a great match for your special day!`) +
			this.line(`Would you like to arrange a site visit of any of the venues below, or please let me know if you need any additional information, I’d be more than happy to help.`) +
			this.line(`The best part? Our service is completely free, and we're here to make the venue-finding process as easy and enjoyable as possible.`) +
			this.line(`In the meantime, feel free to explore more of our beautiful venues here: <a href="https://www.venuecrew.com/uk/?event=wedding">Find An Event Venue For Hire In The UK | Venue Crew</a>`) +
			this.line(`I look forward to hearing from you shortly.`);
		},

		emailSubjectMessage() {
			return 'Your personalised venue recommendations!';
		},
    },
	methods: {
		async viewRecommendationsPortal() {
			this.recommendationPortalLoading = true;

			const link = await RecommendationService.getRecommendationPortalLink(this.leadId, true);
			const recommendationPortalLink = link.data;
			const id = (new Date()).getTime();
			window.open(recommendationPortalLink , '_blank', id);
			this.recommendationPortalLoading = false;
		},

		async searchVenues(leadId, eventId, searchFilters = {}, correctedInvalidDataFromUser = {}) {
            const userId = this.$store.getters['auth/getUserId'];

            let params = {
				lead_id: leadId,
				event_id: eventId,
				user_id: userId
			};

			if (Object.keys(searchFilters).length) {
				params.filters = JSON.stringify(searchFilters);
			}

            if (Object.keys(correctedInvalidDataFromUser).length) {
                params.corrected_invalid_data = JSON.stringify(correctedInvalidDataFromUser);
            }

			return await this.$store.dispatch("venues/karenSearch", params);
		},

        updateKarenListingPageData(data) {
			if (data.venues) {
                this.$store.commit('recommendations/updateKarenVenuesForListView', data.venues);
				this.$emit('venues-list-updated');
			}

			if (data.searchCriteria) {
				this.$emit('update:searchCriteria', data.searchCriteria);
				this.$emit('update:currentSearchCriteria', data.searchCriteria);
			}

			if (data.defaultSearchCriteria) {
				this.$emit('update:defaultSearchCriteria', data.defaultSearchCriteria);
			}

            if (data.selectableLocations) {
				this.$emit('update:selectableLocations', data.selectableLocations);
			}

			if (data.venueStyles) {
				this.$emit('update:venueStyles', data.venueStyles);
			}
        },

        updateData(result) {
            if (result.venues) {
                this.$store.commit('recommendations/updateKarenVenuesForListView', result.venues);

                let karenVenuesForListView = this.$store.getters['recommendations/getKarenVenuesForListView']('all');
                let venuesForMapView = {};
                for (const venueLocationGroupName in karenVenuesForListView) {
                    if (['eventCityVenues', 'otherVenues'].includes(venueLocationGroupName)) {
                        karenVenuesForListView[venueLocationGroupName].forEach(venueRooms => {
                            if (venueRooms.length) {
                                venuesForMapView[venueRooms[0].venue_id] = venueRooms;
                            }
                        });
                    }
                }

                this.$store.commit('recommendations/updateKarenVenuesForMapView', venuesForMapView);
            }

            if (result.searchCriteria) {
                this.searchCriteria = result.searchCriteria;
                this.currentSearchCriteria = result.searchCriteria;
            }

            if (result.defaultSearchCriteria) {
                this.defaultSearchCriteria = result.defaultSearchCriteria;
            }

            if (result.selectableLocations) {
                this.cities = result.selectableLocations;
            }

            if (result.venueStyles) {
                this.venueStyles = result.venueStyles;
            }

            if (result.scoringSettings) {
                this.$store.commit('recommendations/updateScoringSettings', result.scoringSettings);
            }
        },
        addToQueueInStore(venueRoom) {
            if (this.roomsSelectedForRecommendation.length >= maxQueueLength) {
                Notification.error({
                    title: 'Recommendation Limit Reached',
                    message:
                        `You have reached the maximum limit of ${maxQueueLength} recommended venues/rooms. Please review your selections.`,
                    showClose: true
                })

                return;
            }

            let temp = this.roomsSelectedForRecommendation
            temp.push(venueRoom)
            this.$store.commit('recommendations/updateSelectedForRecommendation', {
                leadEventId: this.leadEventId,
                rooms: temp
            })
        },
        removeFromQueueInStore(venueRoom) {
            let temp = this.roomsSelectedForRecommendation;

            let index = -1;
            index = temp.indexOf(venueRoom);

            if (index > -1) {
                temp.splice(index, 1);
            }

            this.$store.commit('recommendations/updateSelectedForRecommendation', {
                leadEventId: this.leadEventId,
                rooms: temp,
            });
        },
        async getPortalLink(leadId){
			const link = await RecommendationService.getRecommendationPortalLink(leadId);

			const basicUrlPattern = new RegExp('^(https?:\\/\\/)?');
			if (link.data && !!basicUrlPattern.test(link.data)) {
				this.portalLoginLink = link.data;
			}
		},
        portalLinkMessage(type) {
			if (this.isCountryAU && this.portalLoginLink) {

				return this.line('I have also added a list of curated venues below, and into your personal Venue Crew dashboard! You can login <a href="' + this.portalLoginLink + '">here</a> and let me know which ones you love, request venue tours, or ask for more recommendations if I’ve missed the mark :)');
			}

			// Retain the old message if the portal login link is not found or if the lead country is not Australia (AU).
			if (type === EnquiryService.EVENT_TYPE_WEDDING) {

				return this.line(`Based on the style of the venues you seem to lean toward, I've also selected some additional spaces below that I think would be perfect for your wedding. I'd love to hear your thoughts and organise site inspections for you when you're ready.`);
			}

			return this.line(`Based on the style of the venues you seem to lean toward, I've also selected some additional spaces below that I think would be perfect for your upcoming event. I'd love to hear your thoughts on these options as well.`);
		},

		line(text, extraLine) {
			extraLine = extraLine || false;
			return `
				<p style="font-family: 'Nunito', Arial, Sans-serif; font-size: 15px; letter-spacing: 0.4px; word-break: break-word; font-weight: 200;">
					${text}
				</p> `
				+ ((extraLine) ? '<p></p>' : '');
		},
	}
};
